
import { mapState } from "vuex";
// APP端用户信息储存到Cookie便于页面调用
export default {
  data() {
    return {
      userData: {
        userRole: null, // 1农户， 2服务商
        access_token: '',
        farmerId: null, // 用户id
      },
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    // 告诉原生当前路由
    // const time1 = new Date().getSeconds()
    // alert(JSON.stringify('页面开始加载公共方法调用-当前秒数： '+time1));
    this.$bridge.callhandler("setAppEvent", { "type": '9', "action": window.location.hash });
    // const time2 = new Date().getSeconds();
    // alert(JSON.stringify('前端调用APP方法-9-服务商首页路由发生改变事件-当前秒数： '+time2));
    this.$bridge.registerhandler("setWebEvent",
      (data) => {
        let info = typeof data === 'string' ? JSON.parse(data) : data;
        if (info.type === 1) {
          // 个人信息
          this.$store.commit("setUserInfo", {
            isApp: true,
            ...info.data,
            // topOffset: /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ? 0 : info.topOffset
          });
          this.$mUtils.Cookie.set('access_token', info.data?.access_token);
        } else if (info.type === 2) {
          // 位置信息
          this.$store.commit("setLocation", {
            lat: info.data.latitude || 39.904989,
            lon: info.data.longitude || 116.405285,
            city: info.data.city || '北京',
            ...info?.data
          });
        } else if (info.type === 4) {
          // 通知刷新页面
          this.$store.commit("setRefresh", true);
        }
      }
    );
    // const time3 = new Date().getSeconds();
    // alert(JSON.stringify('app调用js注册的方法--1:用户信息；2：定位；4：通知我刷新页面-当前秒数： '+time3));
    this.getUserData();
    // const time4 = new Date().getSeconds();
    // alert(JSON.stringify('调用结束-当前秒数： '+time4));
  },
  methods: {
    /**
     * 将个人数据存储起来
     */
    updateUserData() {
      // 1.先判断链接上是否有token（分享出去用）
      let urlQuery = this.$route.query;
      if (urlQuery.token) {
        this.$mUtils.Cookie.set('access_token', urlQuery.token);
      } else {
        // 2.再去APP里面获取（app中使用） 非APP不会调用成功
        // 获取用户信息
        this.$bridge.callhandler("setAppEvent", { "type": '1' },
          (data) => {
            let info = typeof data === 'string' ? JSON.parse(data) : data
            this.$store.commit("setUserInfo", {
              isApp: true,
              ...info,
              // topOffset: /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ? 0 : info.topOffset
            });
            this.$mUtils.Cookie.set('access_token', info.access_token);
          }
        );

        // 获取定位信息
        this.$bridge.callhandler("setAppEvent", { "type": "2" },
          (data) => {
            // 这个时候是原生去开始定位，返回结果可能是在setWebEvent { "type": "2" }中给我结果
            let info = typeof data === 'string' ? JSON.parse(data) : data
            this.$store.commit("setLocation", {
              lat: info.latitude,
              lon: info.longitude,
              ...info
            });

          }
        );
      }
      // if (!this.userInfo.access_token) {
      //   // 如果都没有，就是本地开发，写死一个,正式环境需要注释-----本地开发使用
      //   this.$mUtils.Cookie.set('access_token', 'KNwOE-x0aINo0dy8fv7s6JJMQ4c');
      // }
    },
    getUserData() {
      this.updateUserData();
      this.userData = {
        ...this.userData,
        access_token: this.$mUtils.Cookie.get('access_token'),
      };
      return this.userData;
    },
  }
}
